"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var validatedViewModel_1 = require("./base/validatedViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.workPreferencesPreset = ko.observable("Default");
        this.workPreferencesModalState = ko.observable("selectPreset");
        this.ignoredGenreIds = ko.observableArray();
        this.hideDislike = ko.observable(false);
        this.hideFinished = ko.observable(false);
        this.hideNeuralNetworks = ko.observable(false);
        this.fullIgnoredGenreIds = ko.pureComputed(function () {
            var ids = _.clone(_this.ignoredGenreIds());
            _.forOwn(_this.genres, function (subGenres, genre) {
                if (ids.indexOf(genre) !== -1) {
                    ko.utils.arrayPushAll(ids, subGenres);
                }
            });
            return _.uniq(ids);
        });
        this._ = _;
        this.initWorkPreferencesPreset = function () {
            _this.ignoredGenreIds.subscribe(function (values) {
                _.forOwn(_this.genres, function (subGenres, genre) {
                    if (values.indexOf(genre) !== -1 && _.intersection(values, subGenres).length > 0) {
                        _this.ignoredGenreIds.removeAll(subGenres);
                    }
                });
            });
        };
        this.genres = {
            "1": ["76"],
            "2": ["38", "71", "77", "64", "39", "41", "78", "74", "40", "44", "73", "43", "42", "79", "80"],
            "3": ["28", "29", "30", "31", "34", "33", "36", "32", "63", "35", "37", "81"],
            "4": ["50", "52", "51", "83"],
            "6": ["46", "45", "67"],
            "7": ["53", "57", "54", "55", "56", "68"],
            "8": ["70"],
            "19": ["61", "58", "14", "59", "60", "82"],
            "21": ["66", "48", "47", "72"]
        };
        this.selectWorkPreferencesPreset = function () {
            var preset = _this.workPreferencesPreset();
            if (preset === "Custom") {
                _this.workPreferencesModalState("editCustomPreset");
            }
        };
        this.backToSelectPreset = function () {
            _this.workPreferencesModalState("selectPreset");
        };
        this.saveWorkPreferences = function () {
            var preset = _this.workPreferencesPreset();
            if (preset === "Custom" && _this.ignoredGenreIds().length === 0) {
                _this.errorMessages.push("Выберите хотя бы один жанр или вернитесь назад.");
                return;
            }
            _this.processing(true);
            ajaxUtils_1.AjaxUtils.post("account/workPreferences", {
                preset: _this.workPreferencesPreset(),
                ignoredGenreIds: _this.ignoredGenreIds(),
                hideDislike: _this.hideDislike() !== false,
                hideFinished: _this.hideFinished() !== false,
                hideNeuralNetworks: _this.hideNeuralNetworks() !== false
            })
                .done(function (result) {
                if (!result.isSuccessful) {
                    _this.errorMessages(result.messages);
                    if (result.data && result.data.stackTrace !== undefined) {
                        console.error(result.data.stackTrace);
                    }
                    return;
                }
                _this.workPreferencesModalState("saved");
                setTimeout(function () {
                    _this.reloadPage();
                }, 1500);
            })
                .always(function () {
                _this.processing(false);
            });
        };
        this.clearIgnoredGenres = function () {
            _this.ignoredGenreIds([]);
        };
        this.initWorkPreferencesPreset();
    }
    return ViewModel;
}(validatedViewModel_1.default));
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=workPreferencesPopup.js.map